<a
  class="signup-button"
  mat-raised-button
  routerLink="/signup"
  [queryParams]="signupParams"
  *ngIf="visible"
  @fadeAnimation
>
  <span class="signup-button-label">Sign Up</span>
</a>